import { render, staticRenderFns } from "./CollectCheck.vue?vue&type=template&id=df439154"
import script from "./CollectCheck.vue?vue&type=script&lang=js"
export * from "./CollectCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports